import React from 'react';
import { Tag, Typography, Button } from 'antd';
import { greyScaleTokens, lightBaseTokens } from '../../theme/theme';

const { Text } = Typography;

const SubscriptionOptionRenderer = ({
    subscription,
    subscriptionInfo,
    selectedVariantsCount,
    onUpgradeClick
}) => {
    const getTypeColor = (subscriptionType) => {
        if (!subscriptionType) return 'default';
        const type = subscriptionType.toLowerCase();

        if (type.includes('branded')) return 'blue';
        if (type.includes('smart')) return 'green';
        if (type.includes('additional')) return 'orange';

        return 'default';
    };

    const getSkuStatusColor = () => {
        if (subscriptionInfo.needsUpgrade) return '#ff4d4f'; // Rosso per limite superato
        if (subscriptionInfo.availableSkus <= 5) return '#ff4d4f'; // Rosso per pochi SKU
        if (subscriptionInfo.availableSkus <= 20) return '#faad14'; // Arancione per SKU limitati
        return lightBaseTokens.colorSuccess; // Verde per molti SKU
    };

    // Mostra messaggio di loading se i dati non sono ancora caricati
    if (subscriptionInfo.isLoading) {
        return (
            <div style={{ padding: '0.5rem 0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.25rem' }}>
                    <Text strong style={{ fontSize: '0.875rem' }}>
                        {subscription.name || subscription.id}
                    </Text>
                    <Tag color={getTypeColor(subscription.subscriptionType)} style={{ margin: 0 }}>
                        {subscription.subscriptionType || 'Unknown'}
                    </Tag>
                </div>
                <Text style={{ fontSize: '0.75rem', color: greyScaleTokens.grey600 }}>
                    Loading SKU data...
                </Text>
            </div>
        );
    }

    return (
        <div style={{ padding: '0.5rem 0' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.25rem' }}>
                <Text strong style={{ fontSize: '0.875rem' }}>
                    {subscription.name || subscription.id}
                </Text>
                <Tag color={getTypeColor(subscription.subscriptionType)} style={{ margin: 0 }}>
                    {subscription.subscriptionType || 'Unknown'}
                </Tag>
            </div>

            {/* Mostra sempre le info sui SKU */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Text style={{ fontSize: '0.75rem', color: greyScaleTokens.grey600 }}>
                    {subscriptionInfo.availableSkus} SKU available
                </Text>
                {selectedVariantsCount > 0 && (
                    <Text style={{
                        fontSize: '0.75rem',
                        color: getSkuStatusColor(),
                        fontWeight: 'bold'
                    }}>
                        Will use {selectedVariantsCount} SKU
                    </Text>
                )}
            </div>

            {/* Mostra warning per pochi SKU disponibili */}
            {!subscriptionInfo.needsUpgrade && subscriptionInfo.availableSkus !== "No Limits" && subscriptionInfo.availableSkus <= 10 && (
                <div style={{ marginTop: '0.25rem' }}>
                    <Text style={{ fontSize: '0.6875rem', color: '#faad14' }}>
                        ⚠️ Low SKU availability
                    </Text>
                </div>
            )}

            {/* Mostra bottone Upgrade se il limite è superato */}
            {subscriptionInfo.needsUpgrade && (
                <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text style={{ fontSize: '0.75rem', color: '#ff4d4f' }}>
                        Exceeds SKU limit ({selectedVariantsCount} needed, {subscriptionInfo.availableSkus} available)
                    </Text>
                    <Button
                        type="primary"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onUpgradeClick();
                        }}
                        style={{
                            fontSize: '0.75rem',
                            height: '24px',
                            padding: '0 8px'
                        }}
                    >
                        Upgrade
                    </Button>
                </div>
            )}
        </div>
    );
};

export default SubscriptionOptionRenderer; 